var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.header,{tag:"component",attrs:{"top":_vm.top}}),_c('div',{staticClass:"content"},[_c('router-view',{attrs:{"top":_vm.top}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }